import { useEffect, useState } from 'react';
import { Avatar, Typography, IconButton, Divider, Select, MenuItem, Checkbox, Button, Dialog, AvatarGroup, Tooltip } from '@mui/material';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IMaskInput, IMask } from 'react-imask';
import { SingleDatePicker } from '../../components/RangeDate';
import { StatusBars, TimeStatus } from './staticresorces';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ListAltIcon from '@mui/icons-material/ListAlt';
import UserAvatar from 'components/EIComponents/UserAvatar';
import { ImgMagazine } from 'components/SelectMarket';
import defectIcon from '../../images/others/defectIcon.png'
import ReplayIcon from '@mui/icons-material/Replay';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { DealDetails } from 'utils/formatters';

/*Это файл содержащий форматеры тикетов, тут описанно поведение и внешний вид тикетов для dnd
Drag and drop имеет следующую структуру

./src
    ./api
        ./apiBridges 
            ./dndBridge.js  (Бриджи для дескриптора)
        ./descriptors
            ./addressableStorage.js (Дескрипторы)
    ./components
        ./DragDrop.js (Основной элемент drag end drop)
    ./utils
        ./dndutils
            ./cardformatters.js (Форматеры тикетов)
            ./containerformatters.js  (Форматеры контейнеров)
            ./staticresorces.js (Статические ресурсы)
            ./toppanelformaters.js  (Форматеры панелей фильтров)

Для создания нового элемента он размещается в соответствующем файле, после чего вкладывается в дескриптор, который работает как конструктор для данного меню
*/

const StatusShadows = {
  'Unknown': '0px 0px 6px 2px rgba(178, 189, 191, 0.1), 0px 0px 6px 2px rgba(178, 189, 191, 0.1)',
  'Argent': '0px 0px 6px 2px rgba(178, 189, 191, 0.5), 0px 0px 6px 2px rgba(178, 189, 191, 0.5)',
  'Gold': '0px 0px 6px 2px rgba(255, 234, 115, 0.5), 0px 0px 6px 2px rgba(255, 234, 115, 0.5)',
  'Emerald': '0px 0px 6px 2px rgba(60, 169, 127, 0.5), 0px 0px 6px 2px rgba(60, 169, 127, 0.5)'
}

const StatusColors = {
  'Unknown': 'white',
  'Argent': 'rgba(178, 189, 191, 0.5)',
  'Gold': 'rgba(255, 234, 115, 0.5)',
  'Emerald': 'rgba(60, 169, 127, 0.5)'
}


// Вид тикета для карточек товара
export const CardItemGoods = ({
  ds, 
  data, 
  toggleDrawer, 
  setEmitFlag, 
  handleUpdateTicket, 
}) => {
  // Поскольку тикет может быть свёрнутым и развёрнутым в зависимости от меню, это флаг отвечает за раскрытие и скрытие
  const [expanded, setExpanded] = useState(false);

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  // Изменение данных тикета
  const handleUpdateCard = ({state = null, date = null, end_date = null}) => {

    setEmitFlag(true);
    if(state) 
      handleUpdateTicket(data.id, 'state', state)
    // if(date) //Тут всегда null
    //   console.log('DATE', date)
    //   handleUpdateTicket(data.id, 'content.date', date)

    if (end_date.getFullYear() != '1970')
      handleUpdateTicket(data.id, 'content.end_date', end_date)
  }

  //data.fbs = true

  console.log("data cig", data)

    return (
        <div 
          style={{
            backgroundColor: 'white', 
            // borderLeftColor: "red",
            // borderLeftStyle: "solid",
            // borderLeftWidth: '3px',
            // boxShadow: StatusShadows[data.state] || undefined, 
            borderRadius: "10px"
          }}
          onClick={data.unity? toggleDrawer('right', true, {id: data.id, deals: data.content.deals, products: data.content.products}, undefined, false, `unity_deal`): toggleDrawer('right', true, data.deal_id || data.id, "common", false)}
        >
          <div style={{
            width: '18%', 
            height: '8%',
            background: 'radial-gradient(ellipse 105% 105% at 94% 90%, white 0%, white 90%, transparent 90%, transparent 100%)',
            backgroundColor: StatusColors[data.state] || 'while', 
            position: 'absolute',
            borderRadius: "10px"
          }}></div>
          <div style = {ds.expand ? {position: 'relative', paddingTop: expanded ? '15px' : '0px'} : {position: 'relative', paddingTop: '15px'}}>
              <div style = {{marginLeft: '10px', alignContent: 'center', alignItems: 'center'}}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div style={{display: 'flex', flexFlow: 'row wrap', marginLeft:"3px"}}>
                        {data.cdn && <Typography noWrap sx={{position: 'relative', maxWidth:'100px', overflow: "hidden", fontWeight: 'bold'}}>#{data.cdn} - </Typography>}
                        <Typography
                          noWrap
                          onClick={(e) => {e.stopPropagation(); toggleDrawer('right', true, data.content.user_id, undefined, false, "CliInfo")(e)}}
                          sx={{
                            position: 'relative',
                            marginLeft: '3px',
                            maxWidth: '150px',
                            overflow: 'hidden',
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.08)', // лёгкая подсветка
                              cursor: 'pointer',                     // чтобы показать кликабельность
                              transition: 'background-color 0.2s',   // плавный переход (опционально)
                              borderRadius: "10px"
                            }
                          }}
                        >
                          {data.content.user_id} {data.name}
                        </Typography>
                        {data.box_num && <Typography noWrap sx={{position: 'relative', marginLeft:'5px', maxWidth:'130px', overflow: "hidden"}}>{data.box_type === "start_pallet"? "Приемка" : "Паллет"} {data.box_num}</Typography>}
                      </div>
                      <div style={{marginLeft: 'auto', marginRight: 8}}>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                          <DealDetails value={{...data, actions: {combined: (e) => {e.stopPropagation(); toggleDrawer('right', true, data.id, "moveGuide", data.combined)(e)}}}}/>
                          {/* {data.combined && <IconButton
                              aria-label="more"
                              id="long-button"
                              aria-haspopup="true"
                              onClick={(e) => {e.stopPropagation(); toggleDrawer('right', true, data.id, "moveGuide", data.combined)(e)}}
                              size='small'
                              sx={{marginLeft: 'auto', marginRight: '5px'}}
                          >
                              <ListAltIcon sx={{color: 'gray'}}/>
                          </IconButton>} */}
                          {/* {data.defect && <img src={defectIcon} style={{height: '20px', width: '20px', marginTop: "1px", marginRight:"5px"}}></img>}
                          {data.ret && <KeyboardBackspaceIcon style={{height: '20px', width: '20px',color: 'gray'}}/>}
                          {data.selfret && <ReplayIcon style={{height: '20px', width: '20px', color: 'gray'}}/>} */}
                          <ImgMagazine magazine={data.market} size={20} user_id={data.content.user_id}></ImgMagazine>
                          <IconButton
                              aria-label="more"
                              id="long-button"
                              aria-haspopup="true"
                              // onClick={data.unity? toggleDrawer('right', true, {deals: data.content.deals, products: data.content.products}, undefined, false, `unity_${data.unity}`): toggleDrawer('right', true, data.deal_id || data.id, "common", data.combined)}
                              //Новый вариант ниже
                              // onClick={data.unity? toggleDrawer('right', true, {deals: data.content.deals, products: data.content.products}, undefined, false, `unity_deal`): toggleDrawer('right', true, data.deal_id || data.id, "common", data.combined)}
                              onClick={(e) => {e.stopPropagation(); handleExpansion()}}
                              size='small'
                              sx={{marginLeft: 'auto', marginRight: 0}}
                          >
                            {expanded? <ExpandLessIcon/>: <ExpandMoreIcon/>}
                          </IconButton>
                          {ds.expand ? <Checkbox style={{height:'10px', width:'10px'}} checked={expanded} icon={<ExpandMoreIcon />} checkedIcon={<ExpandLessIcon />} onChange={handleExpansion}/> : <></>}
                        </div>
                    </div>
                  </div>
              </div>
          </div>
          <div style = {ds.expand ? {display:'none', marginLeft: '10px', marginRight: '10px', marginBottom: '10px', marginTop:'3px'} : {marginLeft: '10px', marginRight: '10px', marginBottom: '10px', marginTop:'3px'}}>
          {/* <hr style = {{marginLeft: '5px', marginRight: '5px'}}></hr> */}
          <div style = {{paddingBottom: '10px', marginLeft:"3px"}}>
              <Typography sx={{fontSize: '14px'}}>Кол-во едениц: {data.content.units}</Typography>
              <Typography sx={{fontSize: '14px'}}>Кол-во SKU: {data.content.sku}</Typography>
              {expanded && 
              <Tooltip title={data.content.warehouse_tranzit} >
                <Typography sx={{fontSize: '14px', marginBottom: "2px"}} noWrap maxWidth={'100%'}>Транзитный склад: {data.content.warehouse_tranzit}</Typography>
              </Tooltip>
              }
              {expanded && 
              <Tooltip title={data.content.warehouse_market} >
                <Typography sx={{fontSize: '14px', marginBottom: "2px"}} noWrap maxWidth={'100%'}>Склад назначения: {data.content.warehouse_market}</Typography>
              </Tooltip>
              }
              {expanded && data.unity && <Typography sx={{fontSize: '14px'}}>Кол-во сделок: {data.content.deals.length}</Typography>}
              <div style={{
                  display: 'flex',
                  flexFlow: 'row wrap',
                  marginTop: data.unity? "-10px": "10px",
                  alignItems:'center'
              }}>
                {!data.unity && 
                  <div onClick={(e) => e.stopPropagation()}>
                    <ChangeDateMenu date={data.content.end_date} handleUpdateCard={handleUpdateCard} />
                  </div>
                }
                <div style={{marginLeft: 'auto', marginRight: 0, display: 'flex', flexFlow: 'row wrap', alignItems:'center'}}>
                  {/* {StatusBars.find(item => item.state === data.state).small} */}
                  <AvatarGroup max={2} sx={{'& .MuiAvatar-root': { width: 27, height: 27, fontSize: 15 },}}>
                  {data.content.managers.map((item) => <UserAvatar src={item.data.photo} userData={item} user_id={item.id} size={27}/>) }
                  </AvatarGroup>
                  {/* <ChangeDateMenu date={data.content.date} handleUpdateCard={handleUpdateCard}></ChangeDateMenu> */}
                </div>
              </div>
          </div>
          </div>
        </div>
    )
  }

  // Вид тикета для карточек АХ
export const CardItemAS = ({
  ds, 
  data, 
  toggleDrawer, 
  setEmitFlag, 
  handleUpdateTicket, 
}) => {
  // Поскольку тикет может быть свёрнутым и развёрнутым в зависимости от меню, это флаг отвечает за раскрытие и скрытие
  const [expanded, setExpanded] = useState(false);

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  // Изменение данных тикета
  const handleUpdateCard = ({state = null, date = null, end_date = null}) => {

    setEmitFlag(true);
    if(state) 
      handleUpdateTicket(data.id, 'state', state)
    // if(date) //Тут всегда null
    //   console.log('DATE', date)
    //   handleUpdateTicket(data.id, 'content.date', date)

    if (end_date.getFullYear() != '1970')
      handleUpdateTicket(data.id, 'content.end_date', end_date)
  }

  // console.log("data cig", data)

    return (
        <div onClick={toggleDrawer('right', true, data.deal_id || data.id, "common", false)} style={{backgroundColor: 'white', boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)', borderRadius: "10px", marginTop:"5px"}}>
          <div style = {ds.expand ? {position: 'relative', paddingTop: expanded ? '5px' : '0px'} : {position: 'relative', paddingTop: '5px'}}>
              <div style = {{margin: '5px 15px 5px 15px', display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between'}}>
                  <Typography noWrap sx={{position: 'relative', maxWidth:'100px', overflow: "hidden", fontWeight: 'bold'}}>#{data.cdn} </Typography>
                  <Typography noWrap sx={{position: 'relative', maxWidth:'100px', overflow: "hidden", fontWeight: 'bold'}}>{data.content.units}шт.</Typography>
              </div>
          </div>
        </div>
    )
  }

  // Вид тикета для карточек товара
export const CardItemShipment = ({
  ds, 
  data, 
  toggleDrawer, 
  setEmitFlag, 
  handleUpdateTicket, 
}) => {
  // Поскольку тикет может быть свёрнутым и развёрнутым в зависимости от меню, это флаг отвечает за раскрытие и скрытие
  const [expanded, setExpanded] = useState(false);

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  // Изменение данных тикета
  const handleUpdateCard = ({state = null, date = null, end_date = null}) => {

    setEmitFlag(true);
    if(state) 
      handleUpdateTicket(data.id, 'state', state)
    // if(date) //Тут всегда null
    //   console.log('DATE', date)
    //   handleUpdateTicket(data.id, 'content.date', date)

    if (end_date.getFullYear() != '1970')
      handleUpdateTicket(data.id, 'content.end_date', end_date)
  }

  console.log("data cig 2", data)

    return (
        <div 
          style={{
            backgroundColor: 'white', 
            // boxShadow: StatusShadows[data.state] || undefined, 
            borderRadius: "10px"
          }}
          onClick={data.unity? toggleDrawer('right', true, {deals: data.content.deals, products: data.content.products}, undefined, false, `unity_deal`): toggleDrawer('right', true, data.deal_id || data.id, "common", false)}
        >
          <div style={{
            width: '18%', 
            height: '8%',
            background: 'radial-gradient(ellipse 105% 105% at 94% 90%, white 0%, white 90%, transparent 90%, transparent 100%)',
            backgroundColor: StatusColors[data.state] || 'while', 
            position: 'absolute',
            borderRadius: "10px"
          }}></div>
          <div style = {ds.expand ? {position: 'relative', paddingTop: expanded ? '15px' : '0px'} : {position: 'relative', paddingTop: '15px'}}>
              <div style = {{marginLeft: '10px', alignContent: 'center', alignItems: 'center'}}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div style={{display: 'flex', flexFlow: 'row wrap', marginLeft:"3px"}}>
                        <Typography noWrap sx={{position: 'relative', maxWidth:'100px', overflow: "hidden", fontWeight: 'bold'}}>#{data.cdn} - </Typography>
                        <Typography
                          noWrap
                          onClick={(e) => {e.stopPropagation(); toggleDrawer('right', true, data.content.user_id, undefined, false, "CliInfo")(e)}}
                          sx={{
                            position: 'relative',
                            marginLeft: '3px',
                            maxWidth: '150px',
                            overflow: 'hidden',
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.08)', // лёгкая подсветка
                              cursor: 'pointer',                     // чтобы показать кликабельность
                              transition: 'background-color 0.2s',   // плавный переход (опционально)
                              borderRadius: "10px"
                            }
                          }}
                        >
                          {data.content.user_id} {data.name}
                        </Typography>
                      </div>
                      <div style={{marginLeft: 'auto', marginRight: 8}}>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <DealDetails value={{...data, actions: {combined: (e) => {e.stopPropagation(); toggleDrawer('right', true, data.id, "moveGuide", data.combined)(e)}}}}/>
                            {/* {data.combined && <IconButton
                                aria-label="more"
                                id="long-button"
                                aria-haspopup="true"
                                onClick={(e) => {e.stopPropagation(); toggleDrawer('right', true, data.id, "moveGuide", data.combined)(e)}}
                                size='small'
                                sx={{marginLeft: 'auto', marginRight: '5px'}}
                            >
                                <ListAltIcon/>
                            </IconButton>}
                            {data.defect && <img src={defectIcon} style={{height: '20px', width: '20px', marginTop: "1px", marginRight:"5px"}}></img>}
                            {data.ret && <KeyboardBackspaceIcon style={{height: '20px', width: '20px'}}/>}
                            {data.selfret && <ReplayIcon style={{height: '20px', width: '20px'}}/>} */}
                            <ImgMagazine magazine={data.market} size={20} user_id={data.content.user_id}></ImgMagazine>
                            <IconButton
                                aria-label="more"
                                id="long-button"
                                aria-haspopup="true"
                                // onClick={toggleDrawer('right', true, data.id, "common", data.combined)}
                                onClick={(e) => {e.stopPropagation(); handleExpansion()}}
                                size='small'
                                sx={{marginLeft: 'auto', marginRight: 0}}
                            >
                                {expanded? <ExpandLessIcon/>: <ExpandMoreIcon/>}
                            </IconButton>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
          <div style = {ds.expand ? {display:'none', marginLeft: '10px', marginRight: '10px', marginBottom: '10px', marginTop:'3px'} : {marginLeft: '10px', marginRight: '10px', marginBottom: '10px', marginTop:'3px'}}>
          {/* <hr style = {{marginLeft: '5px', marginRight: '5px'}}></hr> */}
          <div style = {{paddingBottom: '10px', marginLeft:"3px"}}>
              <Tooltip title={data.content.warehouse_tranzit} >
                <Typography sx={{fontSize: '14px', marginBottom: "2px"}} noWrap maxWidth={'100%'}>Транзитный склад: {data.content.warehouse_tranzit}</Typography>
              </Tooltip>
              <Tooltip title={data.content.warehouse_market} >
                <Typography sx={{fontSize: '14px', marginBottom: "2px"}} noWrap maxWidth={'100%'}>Склад назначения: {data.content.warehouse_market}</Typography>
              </Tooltip>              
              {/* <Typography sx={{fontSize: '14px'}}>Кол-во паллет: {data.content.palletCount}</Typography>
              <Typography sx={{fontSize: '14px'}}>Кол-во коробов: {data.content.boxCount}</Typography>
              <Typography sx={{fontSize: '14px'}}>Кол-во ед.: {data.content.units}</Typography> */}
              <div style={{display: 'flex', flexDirection: "row", justifyContent: "space-between", marginRight: "7px"}}>
                <Typography sx={{fontSize: '14px'}}>Паллет: {data.content.palletCount}</Typography>
                <Typography sx={{fontSize: '14px'}}>Коробов: {data.content.boxCount}</Typography>
                {expanded && <Typography sx={{fontSize: '14px'}}>Единиц: {data.content.units}</Typography>}
              </div>
              {/* <Typography sx={{fontSize: '14px'}}>
                Кол-во паллет: {data.content.palletCount} коробов: {data.content.boxCount} ед.: {data.content.units}
              </Typography> */}
              <div style={{
                  display: 'flex',
                  flexFlow: 'row wrap',
                  marginTop: 10,
                  alignItems:'center'
              }}>
                {/* <ChangeOnlyDateMenu date={data.content.end_date} handleUpdateCard={handleUpdateCard}/> */}
                <div onClick={(e) => {e.stopPropagation();}}>
                  <ChangeDateMenu date={data.content.end_date} handleUpdateCard={handleUpdateCard}/>
                </div>
                <div style={{marginLeft: 'auto', marginRight: 0, display: 'flex', flexFlow: 'row wrap', alignItems:'center'}}>
                  {/* {StatusBars.find(item => item.state === data.state).small} */}
                  <AvatarGroup max={2} sx={{'& .MuiAvatar-root': { width: 27, height: 27, fontSize: 15 },}}>
                  {data.content.managers.map((item) => <UserAvatar src={item.data.photo} userData={item} user_id={item.id} size={27}/>) }
                  </AvatarGroup>
                  {/* <ChangeDateMenu date={data.content.date} handleUpdateCard={handleUpdateCard}></ChangeDateMenu> */}
                </div>
              </div>
          </div>
          </div>
        </div>
    )
  }
  
  // Форматер для меню выбора даты
  export const blocks = {
    h: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 23,
      maxLength: 2,
    },
    m: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 59,
      maxLength: 2,
    }
  }

  // Меню изменения даты и времени для тикета
  const ChangeDateMenu = ({date, handleUpdateCard}) => {

    // Флаг открытия и скрытия меню
    const [open, setOpen] = useState(false);
    // Переменная для даты
    const [newDate, setNewDate] = useState(null);
    // Переменная для времени
    const [time, setTime] = useState([0,0]);
    const [timeText, setTimeText] = useState("00:00");

    // Изменение времени
    const handeUpdateTime = (time) => {
      console.log("time", time)
      let split = time.split(':');
      if (!split[1]){split[1] = 0}
      setTime(split)
      setTimeText(time)
    }
    // Обработчик открытия меню даты
    const DialoghandleClickOpen = () => {
      setOpen(true);
    };

    // Обработчик закрытия меню даты
    const DialoghandleClose = () => {
      // setNewDate(null);
      setOpen(false);
    } 

    // Обработчик добавления даты
    const DialoghandleAdd = () => {
      if (newDate) {
        handleUpdateCard({end_date:new Date(new Date(newDate).setHours(time[0], time[1], 0, 0))})
        // setNewDate(null);
        setOpen(false);
      }
      else {

      }
    }
    const myDate = new Date(date);
    const nowDate = new Date();
    const midleDate = new Date(new Date(date).getTime() - (3 * 3600000));

    useEffect(() => {
        if (date) {
            const options = {
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
              // timeZone: 'UTC' // Фиксируем часовой пояс UTC
            };
            const realDate = new Date(date);
            // @ts-ignore
            let timeString = realDate.toLocaleTimeString('ru-RU', options)
            let timeList = timeString.split(":")
            setTime([parseInt(timeList[0]), parseInt(timeList[1])])
            setTimeText(timeString)

            let dateString = String(date).slice(0, 10); 
            setNewDate(new Date(dateString))
        }
    }, [date]);

    return (
      <div
      style={{
        marginLeft: 0, marginRight: 'auto'
      }}
      >
        <div 
          style={{
            backgroundColor: (nowDate < midleDate) ? '#c1c1c1' : ((nowDate >= midleDate) && (nowDate <= myDate)) ? '#febf58' : (nowDate > myDate) ? '#ff7978 ' : '#febf58',
            borderRadius:'12px', 
            padding:'3px', 
            height:'26px', 
            display: 'flex', 
            flexFlow: 'row wrap', 
            alignItems:'center'
          }}
          onClick={DialoghandleClickOpen}
        >
          <Typography variant="body1" sx={{marginLeft:'5px', marginRight:'5px', fontWeight: '200', fontSize: '13px', color:'#fff',}}>
            {myDate.toLocaleDateString("ru", {month: 'short', day: 'numeric'})}{timeText !== "00:00"? ` - ${timeText}`:""}
          </Typography>
        </div>
          <Dialog
            open={open}
            onClose={DialoghandleClose}
            PaperProps={{ sx: { borderRadius: "40px" } }}
          >
          <div style={{height:'620px', width:'500px', justifyContent: 'center', alignItems: "center"}}>
            <div style={{display:'flex', justifyContent: 'center', alignItems: "center", marginBottom:'15px'}}>
              <Typography variant="body1" sx={{fontWeight: '500', fontSize: '16px', marginTop:'20px', marginLeft:'20px'}}>{myDate.toLocaleDateString("ru", { weekday: 'short', month: 'short', day: 'numeric'})}</Typography>
            </div>
            <Divider/>
            <
            // @ts-ignore
            SingleDatePicker 
              defaultDate={newDate} onChange={(nd) => {console.log('nd', nd); setNewDate(nd)}}/>
            <Divider/>
            {/*  */}
            <IMaskInput value={timeText} onAccept={(value, mask) => handeUpdateTime(value)} style={{marginLeft:'42%', marginTop:'5px', marginBottom:'5px', width: '80px', height: '23px', fontSize: '14px',textAlign:'center', borderRadius: '20px', border: '2px solid #078376'}} placeholder='00:00' mask="h:m" blocks={blocks} definitions={{'#': /[1-9]/,}} overwrite/>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop:'20px'}}>
                <Button variant="contained" onClick={DialoghandleClose} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}} >Отмена</Button>
                <Button variant="contained" onClick={DialoghandleAdd} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}}>Изменить</Button>
            </div>
          </div>
          
        </Dialog>
      </div>
    );
  }

  // Компонент изменения только даты тикета
export const ChangeOnlyDateMenu = ({date, handleUpdateCard}) => {
    // Флаг открытия окна
    const [open, setOpen] = useState(false);
    // Переменная для даты
    const [newDate, setNewDate] = useState(null);

    // Обработчик открытия окна
    const DialoghandleClickOpen = () => {
      setOpen(true);
    };

    // Обработчик закрытия окна
    const DialoghandleClose = () => {
      setNewDate(null);
      setOpen(false);
    }

    // Обработчик добавления даты в тикет
    const DialoghandleAdd = () => {
      handleUpdateCard({end_date:new Date(new Date(newDate).getTime()+(23*3600000)+(59*60000))})
      console.log(newDate);
      setNewDate(null);
      setOpen(false);
    }
    const myDate = new Date(date);
    const nowDate = new Date();
    const midleDate = new Date(new Date(date).getTime() - (3 * 24 * 3600000));

    return (
      <div
      style={{
        marginLeft: 0, marginRight: 'auto'
      }}
      >
        <div 
          style={{
            backgroundColor: (nowDate < midleDate) ? '#c1c1c1' : ((nowDate >= midleDate) && (nowDate <= myDate)) ? '#febf58' : (nowDate > myDate) ? '#ff7978 ' : '#febf58',
            borderRadius:'12px', 
            padding:'3px', 
            height:'26px', 
            display: 'flex', 
            flexFlow: 'row wrap', 
            alignItems:'center'
          }}
          onClick={DialoghandleClickOpen}
        >
          <Typography variant="body1" sx={{marginLeft:'5px', marginRight:'5px', fontWeight: '200', fontSize: '13px', color:'#fff',}}>{myDate.toLocaleDateString("ru", {month: 'short', day: 'numeric'})}</Typography>
        </div>
          <Dialog
            open={open}
            onClose={DialoghandleClose}
            PaperProps={{ sx: { borderRadius: "40px" } }}
          >
          <div style={{height:'590px', width:'500px', justifyContent: 'center', alignItems: "center"}}>
            <div style={{display:'flex', justifyContent: 'center', alignItems: "center", marginBottom:'15px'}}>
              <Typography variant="body1" sx={{fontWeight: '500', fontSize: '16px', marginTop:'20px', marginLeft:'20px'}}>{myDate.toLocaleDateString("ru", { weekday: 'short', month: 'short', day: 'numeric'})}</Typography>
            </div>
            <Divider/>
            <SingleDatePicker 
// @ts-ignore
            date={new Date(date)} onChange={setNewDate}/>
            <Divider/>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop:'20px'}}>
                <Button variant="contained" onClick={DialoghandleClose} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}} >Отмена</Button>
                <Button variant="contained" onClick={DialoghandleAdd} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}}>Изменить</Button>
            </div>
          </div>
          
        </Dialog>
      </div>
    );
  }

  export const ChangeOnlyDateMenuWithYear = ({ date, handleUpdateCard }) => {
    const [open, setOpen] = useState(false);
    const [newDate, setNewDate] = useState(null);

    const DialoghandleClickOpen = () => {
      setOpen(true);
    };

    const DialoghandleClose = () => {
      setNewDate(null);
      setOpen(false);
    };

    const DialoghandleAdd = () => {
      if (newDate) {
        // Устанавливаем конец выбранного дня (23:59:59)
        const endOfDay = new Date(new Date(newDate).getTime() + 23 * 3600000 + 59 * 60000);
        handleUpdateCard({ end_date: endOfDay });
      }
      setNewDate(null);
      setOpen(false);
    };

    const myDate = new Date(date);
    const nowDate = new Date();
    const midleDate = new Date(new Date(date).getTime() - 3 * 24 * 3600000);

    // Форматирование с годом (пример: "12 мар 2025")
    const formattedDate = myDate.toLocaleDateString("ru", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });

    // Форматирование для заголовка диалога (пример: "ср, 12 мар 2025")
    const dialogHeaderDate = myDate.toLocaleDateString("ru", {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
    });

    return (
      <div style={{ marginLeft: 0, marginRight: "auto" }}>
        <div
          style={{
            backgroundColor:
              nowDate < midleDate
                ? "#c1c1c1"
                : nowDate >= midleDate && nowDate <= myDate
                ? "#febf58"
                : nowDate > myDate
                ? "#ff7978"
                : "#febf58",
            borderRadius: "12px",
            padding: "3px",
            height: "26px",
            display: "flex",
            flexFlow: "row wrap",
            alignItems: "center",
          }}
          onClick={DialoghandleClickOpen}
        >
          <Typography
            variant="body1"
            sx={{
              marginLeft: "5px",
              marginRight: "5px",
              fontWeight: "200",
              fontSize: "13px",
              color: "#fff",
            }}
          >
            {formattedDate}
          </Typography>
        </div>

        <Dialog
          open={open}
          onClose={DialoghandleClose}
          PaperProps={{ sx: { borderRadius: "40px" } }}
        >
          <div
            style={{
              height: "590px",
              width: "500px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "500",
                  fontSize: "16px",
                  marginTop: "20px",
                  marginLeft: "20px",
                }}
              >
                {dialogHeaderDate}
              </Typography>
            </div>
            <Divider />
            {/* 
              SingleDatePicker должен поддерживать выбор года.
              Если он этого не умеет – замените на DatePicker из MUI X 
              или на стандартный input type="date".
            */}
            <SingleDatePicker
              // @ts-ignore
              date={myDate}
              onChange={setNewDate}
              // Если компонент поддерживает – включите выбор года
              // showYearPicker 
            />
            <Divider />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <Button
                variant="contained"
                onClick={DialoghandleClose}
                sx={{
                  textTransform: "none",
                  margin: "10px",
                  fontWeight: "bold",
                  backgroundColor: "#078376",
                }}
              >
                Отмена
              </Button>
              <Button
                variant="contained"
                onClick={DialoghandleAdd}
                sx={{
                  textTransform: "none",
                  margin: "10px",
                  fontWeight: "bold",
                  backgroundColor: "#078376",
                }}
              >
                Изменить
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
    );
  };


  // Вид тикета для карточек клиентов
  export const CardItemClient = ({ 
    data, 
    toggleDrawer, 
    setEmitFlag, 
    handleUpdateTicket, 
  }) => {

    console.log("data CIC", data)

    // Обработчик изменения данных в карточке клиента
    const handleUpdateCard = ({state = null, date = null}) => {
      setEmitFlag(true);
      if(state) 
        handleUpdateTicket(data.id, 'state', state)
      if(date) 
        handleUpdateTicket(data.id, 'content.date', date)
    }


    return (
        <div style={{backgroundColor: 'white', boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)', borderRadius: "10px"}}>
          <div style = {{position: 'relative', paddingTop: '15px'}}>
              <div style = {{marginLeft: '10px', alignContent: 'center', alignItems: 'center'}}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                      <UserAvatar src={data.data.photo} userData={data} user_id={data.id} size={35}/>
                      <Typography noWrap sx={{position: 'relative', marginLeft:'10px', maxWidth:'150px', overflow: "hidden", fontWeight: 'bold'}}>{data.fio}</Typography>
                      <Typography noWrap sx={{position: 'relative', marginLeft:'5px', width:'50px', minWidth:'50px', overflow: "hidden", fontWeight: 'bold'}}>{data.id}</Typography>
                      <IconButton
                          aria-label="more"
                          id="long-button"
                          aria-haspopup="true"
                          onClick={toggleDrawer('right', true, data.id)}
                          size='small'
                          sx={{marginLeft: 'auto', marginRight: 0}}
                      >
                          <MoreVertIcon/>
                      </IconButton>
                  </div>
                  <div
                      style = {{
                          marginTop: '5px',
                      }}
                  >
                      <Typography variant="body1" sx={{fontWeight: '200', fontSize: '15px'}}>{data.mobile_number}</Typography>
                      <Tooltip title={data.email} placement="top" arrow disableHoverListener={data.email.length < 30} //можно поменять, я просто хз, с какой длины почты отображать tooltip
                        componentsProps={{tooltip: {sx:{fontSize: '16px',padding: '8px 12px',},},}}>
                        <Typography 
                            variant="body1" 
                            sx={{
                                fontWeight: '200', 
                                fontSize: '15px',
                                maxWidth: '90%',
                                position: 'relative',
                                overflow: 'hidden', 
                                whiteSpace: 'nowrap',
                                '&::after': {
                                    content: '""',
                                    position: 'absolute',
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    width: '30px',
                                    background: () => `linear-gradient(to right, rgba(255, 255, 255, 0), #fff)`,
                                },
                            }}
                        >
                            {data.email}
                        </Typography>
                    </Tooltip>
                  </div>
              </div>
          </div>
          <hr style = {{'margin': '10px'}}></hr>
          <div style = {{'margin': '10px', paddingBottom: '10px'}}>
              <Typography>Количество сделок:</Typography>
              <Typography sx={{fontSize: '30px'}} >{data.dealcount}</Typography>
              <div style={{
                  display: 'flex',
                  flexFlow: 'row wrap',
                  alignItems: 'center',
              }}>
                  <Select
                        value={data.state}
                        onChange={e => handleUpdateCard({state:e.target.value})}
                        // @ts-ignore
                        sx = {{position: 'relative', display:'flex', alignItems: 'center',  fontWeight: 'bold', backgroundColor:'rgba(0, 0, 0, 0)',height:'31px', borderRadius:'10px','& .MuiOutlinedInput-input': {p: 0, border: '0px'}, '.MuiOutlinedInput-notchedOutline': { border: 'none !important' }}}
                        inputProps={{ IconComponent: () => null }}
                        MenuProps={{
                          sx: {
                              '& .MuiMenu-paper': {
                                  backgroundColor: 'rgba(0, 0, 0, 0)',
                                  boxShadow: 'none',
                                  
                              }
                              }}}
                      >
                        {StatusBars.map(el => {return <MenuItem key={el.state} value={el.state} style={{backgroundColor:el.color, borderRadius:'10px', marginBottom: '5px'}}>{el.show}</MenuItem>})}
                      </Select>
                      <div style={{marginLeft: 'auto', marginRight: 0, display: 'flex', flexFlow: 'row wrap', alignItems:'center'}}>
                        <AvatarGroup max={2} sx={{'& .MuiAvatar-root': { width: 27, height: 27, fontSize: 15 },}}>
                        {data.managers.map(item => <UserAvatar src={item.data.photo} userData={item} user_id={item.id} size={27}/>) }
                        </AvatarGroup>
                        {/* <ChangeDateMenu date={data.content.date} handleUpdateCard={handleUpdateCard}></ChangeDateMenu> */}
                      </div>
              </div>
          </div>
        </div>
    )
  }



  // Вид тикета для карточек не обработанных звонков
  export const CardNumber = ({
    data,
    toggleDrawer,
  }) => {
    return (
        <div>
          <div style = {{'margin': '10px', paddingBottom:'5px', paddingTop:'5px'}}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography noWrap sx={{position: 'relative', marginLeft:'10px', maxWidth:'150px', overflow: "hidden", fontWeight: 'bold'}}>Неизвестный:</Typography>
                <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-haspopup="true"
                    onClick={toggleDrawer('right', true, 23)}
                    size='small'
                    sx={{marginLeft: 'auto', marginRight: 0}}
                >
                    <MoreVertIcon/>
                </IconButton>
            </div>
            <Typography noWrap sx={{position: 'relative', marginLeft:'10px', maxWidth:'180px', minWidth:'50px', overflow: "hidden", fontWeight: 'bold'}}>{data.number}</Typography>
            <div style={{
                  display: 'flex',
                  flexFlow: 'row wrap',
                  alignItems: 'center',
              }}>
                <Typography noWrap sx={{position: 'relative', marginLeft:'10px', maxWidth:'150px', overflow: "hidden"}}>{data.content.date.toLocaleDateString("ru", { hour: 'numeric', minute:'numeric', month: 'short', day: 'numeric'})}</Typography>
            <div style={{marginLeft: 'auto', marginRight: 0, display: 'flex', flexFlow: 'row wrap', alignItems:'center', paddingBottom:'5px'}}>
              <AvatarGroup max={2} sx={{'& .MuiAvatar-root': { width: 27, height: 27, fontSize: 15 },}}>
              {data.content.managers.map(item => <UserAvatar src={item.data.photo} userData={item} user_id={item.id} size={27}/>) }
              </AvatarGroup>
            </div>
            </div>
          </div>
        </div>
    )
  }



  // Шаблон карточек, определяющий логику их поведения при dnd
  export const TemplateCard = ({ 
    ds, 
    data,
    handleDragging, 
    isDragging, 
    toggleDrawer, 
    setInsertelement, 
    setEmitFlag, 
    listItems, 
    setListItems, 
    handleUpdateTicket,
    dragItemRef,
    selectedColumnRef,
    cloneItemRef,
    last
  }) => {

    // Обработчик начала перетаскивания
    const handleDragStart = (e) => {
        // Сохраняем ссылку на перетаскиваемый элемент
        dragItemRef.current = e.target;
        // Клонируем перетаскиваемый элемент для создания теневого клона и создаём на него ссылку
        cloneItemRef.current = e.target.cloneNode(true);
        // Стилизуем клона
        cloneItemRef.current.style.opacity = '0.5';
        e.target.style.boxShadow = '0 1px 6px rgba(0, 0, 0, 0.6), 0 1px 4px rgba(0, 0, 0, 0.7)'
        // Складываем данные о перетаскиваемом тикете в dataTransfer
        e.dataTransfer.setData('text', `${data.id}|${data.status}`)
        // Прячем оригинальный тикет. Таймаут нужен чтобы обработать скрытие в eventLoop после того как был склонирован тикет. В противном случае слонирование прервётся изменением состояния тикета и мы не получим клона
        setTimeout(() => {
          if (dragItemRef.current) {
            dragItemRef.current.style.visibility = 'hidden';
            dragItemRef.current.style.height = '0px';
            dragItemRef.current.style.overflow = 'hidden';
            dragItemRef.current.style.margin = '0px';
            dragItemRef.current.style.padding = '0px';
          }
        }, 0);
        // Выставляем флаг перетаскивания в true
        handleDragging(true);
    }

    // Обработчик конца перетаскивания. В нём очищаются ссылки и возращаются начальные состояния компонентов в случае если не произошло дропа
    const handleDragEnd = (e) => { dragItemRef.current.style.visibility = 'visible'; dragItemRef.current.style.height = ''; dragItemRef.current.style.margin = '10px'; dragItemRef.current.style.padding = ''; dragItemRef.current.style.overflow = ''; cloneItemRef.current.remove(); dragItemRef.current.style.boxShadow = '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)'; dragItemRef.current.style.opacity = '1'; }
  
    // Обработчик перетаскивания карточки над карточкой. Он реализует основной механизм смещения и отображения теневого клона тикета
    const handleDragOver = (e) => {
      if (isDragging){ // Проверка на перетаскивание
      e.preventDefault() // Перехват обработки с других уровней
      const tasksListElement = selectedColumnRef.current; // Получение таргет стобца, над которым происходит перетаскивание
      if (tasksListElement){ // Проверка на наличие столбца
        let activeElement = cloneItemRef.current; // Получение клона (вытаскивание из ссылок немного ускоряют работу)
        const currentElement = e.currentTarget; // Получение тикета над которым происходит перетаскивание
        const isMoveable = (activeElement !== currentElement) && (currentElement !== dragItemRef.current); // Если тикет над которым мы перетаскиваем это сам клон, то прекращаем обработку 
        if (!isMoveable) {
          cloneItemRef.current.style.display = 'none';
          return;
        }
        if (window.getComputedStyle(cloneItemRef.current).display === "none") cloneItemRef.current.style.display = ''; // Проверка отображения клона. Если он не виден, показываем его
        if (currentElement.id !== activeElement.id){
          if (currentElement.getBoundingClientRect().y < activeElement.getBoundingClientRect().y){ // Проверка позиции мыши при перетягивании тикета, для определения позации вставки
            currentElement.insertAdjacentElement('beforebegin', activeElement)
            setInsertelement({position:'beforebegin', idanchor:data.id}) // Фиксация позиции перетаскивания
          }
          else{
            currentElement.insertAdjacentElement('afterend', activeElement)
            setInsertelement({position:'afterend', idanchor:data.id}) // Фиксация позиции перетаскивания
          }
        }
      }}
    }

    const Card = ds.formatter;  // Вытаскиваем из дескриптора визуал карточки
  
    return (
      <div 
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.4)',
          borderBottomRightRadius: last? '10px' : "0px",
          borderBottomLeftRadius: last? '10px' : "0px",
        }}
      >
        <div
          className='card-container'
          id={data.id}
          key={data.id}
          draggable
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd}
          onDragOver={handleDragOver}
          style = {{
            // margin:'0px 0px 0px 0px',
            padding: "10px 10px 10px 10px",
            // backgroundColor:'white', 
            borderRadius:'10px', 
            // boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)',
            transition: 'opacity 0.1s ease, height 0.1s ease, margin 0.1s ease, padding 0.1s ease',
          }}
        >
          <Card
            ds={ds}
            data={data}
            toggleDrawer={toggleDrawer}
            setEmitFlag={setEmitFlag}
            setListItems={setListItems}
            handleUpdateTicket={handleUpdateTicket}
            listItems={listItems}
            handleDragStart={handleDragStart}
            handleDragEnd={handleDragEnd}
            handleDragOver={handleDragOver}
          />
        </div>
      </div>
    )
  }


  // Обёртка карточек для фильтрации. Тут соджержимое карточек сопоставляется с фильтром
  export const CardsWithFilter = ({
    ds, 
    items, 
    showItems, 
    filter,  
    isDragging, 
    handleDragging, 
    toggleDrawer, 
    setInsertelement, 
    setEmitFlag, 
    setListItems, 
    handleUpdateTicket,
    dragItemRef,
    selectedColumnRef,
    cloneItemRef
  }) => {

    if (!showItems || !items) return null;
      // Для быстроты сначала фильтруем, потом отображаем
      const filteredItems = items.filter((el) => {
        const item = showItems[el];
        if (!item) return false;

        const nameMatch = filter.name
          ? (item.name?.toLowerCase().includes(filter.name) || //только для сделок
            String(item.cdn).toLowerCase().includes(filter.name) || //только для сделок
            item.fio?.toLowerCase().includes(filter.name)) || //Только для клиентов
            (item.fio && String(item.id).toLowerCase().includes(filter.name)) || //Только для клиентов
            (item.content?.deals && item.content.deals.find((fel) => String(fel.cdn).includes(filter.name))) //Для хранения
          : true;

        const timeMatch = filter.timeStart && item.content.date
          ? (item.content.date.getTime() >= new Date(filter.timeStart) && item.content.date.getTime() <= new Date(filter.timeEnd))
          : true;

        const statusMatch = filter.status.length > 0 && item.state
          ? filter.status.includes(item.state)
          : true;

        const dateMatch = filter.dateStart && item.content.end_date
          ? (new Date(item.content.end_date) >= new Date(filter.dateStart) && new Date(item.content.end_date) <= new Date(filter.dateEnd))
          : true;

        return nameMatch && timeMatch && statusMatch && dateMatch;
  });

  console.log("filteredItems", filteredItems)

  //Мапим отфильтрованные карточки
  return filteredItems.map((el, index) => {
    const item = showItems[el];
    return (
      <TemplateCard
        key={item.id}
        ds={ds}
        data={item}
        handleDragging={handleDragging}
        toggleDrawer={toggleDrawer}
        isDragging={isDragging}
        setInsertelement={setInsertelement}
        setEmitFlag={setEmitFlag}
        setListItems={setListItems}
        handleUpdateTicket={handleUpdateTicket}
        listItems={items}
        dragItemRef={dragItemRef}
        selectedColumnRef={selectedColumnRef}
        cloneItemRef={cloneItemRef}
        last={index === filteredItems.length-1}
      />
    );
  });
};